<template>
  <div>
    <div v-if="global.selectedAppTab == 6">
      <active-session-card :client-portal="clientPortal"></active-session-card>
      <client-portal-card></client-portal-card>
      <transaction-card :client-portal="clientPortal"></transaction-card>
    </div>
  </div>
</template>
<script>
import { defineComponent } from "@vue/composition-api";
import global from "@/composables/global";
import ActiveSessionCard from "@/components/ClientPortal/ActiveSessionCard";
import ClientPortalCard from "@/components/ClientPortal/ClientPortalCard";
import TransactionCard from "@/components/ClientPortal/TransactionCard";

export default defineComponent({
  components: {
    ActiveSessionCard,
    ClientPortalCard,
    TransactionCard,
  },
  props: {
    clientPortal: {
      type: Object,
      required: true,
    },
  },
  setup() {
    return {
      global,
    };
  },
});
</script>
